import Button from 'components/Button'
import FilterDiv from 'components/FilterDiv'
import DegreeAndDepartmentFilter from 'modules/Courses/Partials/CourseFilter/Partials/DegreeAndDepartmentFilter'
import DurationFilter from 'modules/Courses/Partials/CourseFilter/Partials/DurationFilter'
import ExamTypeFilter from 'modules/Courses/Partials/CourseFilter/Partials/ExamTypeFilter'
import StatusFilter from 'modules/Courses/Partials/CourseFilter/Partials/StatusFilter'
import { dropDownValues } from 'modules/Courses/actions'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'
import React, { useEffect, useState } from 'react'
import { degreeListConvertion } from 'utils/degreeListConversion'
import VirtualizedCheckboxGroup from '../../../../components/UIComponents/Filter'

const { TabPane } = StyledTab

const CourseFilter = ({
  setQuery,
  degreeList,
  duration,
  setDuration,
  setExamType,
  setDegreeFilter,
  listOfStudentSkills,
  setSkillList,
  setStatusFilter,
  skillListData,
  getSkillList,
  setPage,
  degreeFilterList,
  domainFilter,
  setDomainFilter,
  setSpecializationFilter,
}) => {
  const [filters, setFilters] = useState({})
  const [durationValue, setDurationValue] = useState([])
  const [statusValue, setStatusValue] = useState([])
  const [examTypeValue, setExamTypeValue] = useState([])
  const [streamIdList, setStreamIdList] = useState([])
  const [specializationIdList, setSpecializationIdList] = useState([])
  // Owned here rather than in the tree, which FilterDiv destroys on every close.
  const [degreeCheckedKeys, setDegreeCheckedKeys] = useState([])
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [degreeListData, setDegreeListData] = useState([])
  const [domainId, setDomainId] = useState([])
  const [domainName, setDomainName] = useState([])
  const [domainValues, setDomainValues] = useState([])
  const [domainSearch, setDomainSearch] = useState([])
  const [debounce, setDebounce] = useState(() => domainSearch)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dropDownValues({ url: 'crud/domains?status=1' })
        setDomainValues(response.data.result)
      } catch (error) {
        console.error('Error fetching domain values:', error)
      }
    }
    fetchData()
  }, [debounce])
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounce(domainSearch)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [domainSearch])
  const handleSelectedIdsChange = selectedIds => {
    const names = domainValues
      .filter(item => selectedIds.includes(item.id))
      .map(item => item.id)
    setDomainId(names)
  }

  useEffect(() => {
    const updatedData = degreeListConvertion(degreeList)
    setDegreeListData(updatedData)
  }, [degreeList])

  const onStatusChange = status => {
    if (status.length) {
      setStatusValue([status[status.length - 1]])
      setFilters(prev => {
        return { ...prev, status: status[status.length - 1] }
      })
    } else {
      setStatusValue([])
      let filterCopy = { ...filters }
      delete filterCopy.status
      setFilters(filterCopy)
    }
  }
  const onDurationChange = durations => {
    setDurationValue(durations)
  }
  const onExamTypeChange = examtype => {
    setExamTypeValue(examtype)
  }

  const submitFilter = () => {
    setDuration(durationValue)
    setExamType(examTypeValue)
    setDegreeFilter(streamIdList)
    setStatusFilter(statusValue)
    setSpecializationFilter(specializationIdList)
    setIsMenuOpen(false)
    setDomainFilter(domainId)
    setPage(0)
  }

  const onDegreeFilterChange = data => {
    setStreamIdList(data)
  }
  
  const onSpecializationFilterChange = data => {
    setSpecializationIdList(data)
  }
  const menu = (
    <MenuFlex column>
      <StyledTab tabPosition={'left'} type="card">
        <TabPane tab="Degree & Department" key="1">
          <DegreeAndDepartmentFilter
            degreeList={degreeListData}
            setDegreeList={onDegreeFilterChange}
            setSpecializationList={onSpecializationFilterChange}
            checkedKeys={degreeCheckedKeys}
            setCheckedKeys={setDegreeCheckedKeys}
          />
        </TabPane>
        <TabPane tab="Duration" key="2">
          <DurationFilter
            setStatusList={onDurationChange}
            value={durationValue}
          />
        </TabPane>
        <TabPane tab="Exam Type" key="3">
          <ExamTypeFilter
            setStatusList={onExamTypeChange}
            value={examTypeValue}
          />
        </TabPane>

        <TabPane tab="Domain">
          <VirtualizedCheckboxGroup
            options={domainValues}
            value={domainId}
            valueParam="id"
            labelParam="name"
            setValue={handleSelectedIdsChange}
            stateName={domainName}
            setStateName={setDomainName}
            filterId={true}
            saveById={true}
            degreeSearch={domainSearch}
            setDegreeSearch={setDomainSearch}
          />
        </TabPane>
        <TabPane tab="Status" key="5">
          <StatusFilter setStatusList={onStatusChange} value={statusValue} />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setIsMenuOpen(false)
          }}
        />
        <Button.Primary onClick={submitFilter} text="Apply Filter" />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <FilterDiv
      overlayMenu={menu}
      open={isMenuOpen}
      setOpen={flag => {
        setIsMenuOpen(flag)
      }}
    />
  )
}

export default CourseFilter
